import { AuthorRoles, ChatMessage } from "../../domain/messages/models/ChatMessage";


const formatTimestamp = (ts: number): string => {
    const d = new Date(ts);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
};

const stripBase64Images = (content: string): string =>
    content.replace(/!\[([^\]]*)\]\(data:[^)]+\)/g, (_, alt: string) =>
        alt ? `[image: ${alt}]` : '[image]',
    );

export const formatTranscript = (messages: ChatMessage[]): string =>
    messages
        .filter((m) => m.content?.trim())
        .map((m) => {
            const role = m.authorRole === AuthorRoles.Bot ? 'Assistant' : 'User';
            return `[${formatTimestamp(m.timestamp)}] ${role}:\n${stripBase64Images(m.content)}`;
        })
        .join('\n\n');
